import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { API_REQUEST_URL } from '../../../common/apiConfig';
import {
  MANAGE_SUBS_ADD_CUSTOMERS_BEGIN,
  MANAGE_SUBS_ADD_CUSTOMERS_SUCCESS,
  MANAGE_SUBS_ADD_CUSTOMERS_FAILURE,
  MANAGE_SUBS_ADD_CUSTOMERS_DISMISS_ERROR,
} from './constants';

export function addCustomers(args = {}) {
  return (dispatch,getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: MANAGE_SUBS_ADD_CUSTOMERS_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      const doRequest = axios.post(`${API_REQUEST_URL}/addCustomers`, args, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: MANAGE_SUBS_ADD_CUSTOMERS_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: MANAGE_SUBS_ADD_CUSTOMERS_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissAddCustomersError() {
  return {
    type: MANAGE_SUBS_ADD_CUSTOMERS_DISMISS_ERROR,
  };
}

export function useAddCustomers() {
  const dispatch = useDispatch();

  const { addCustomersPending, addCustomersError } = useSelector(
    state => ({
      addCustomersPending: state.manageSubs.addCustomersPending,
      addCustomersError: state.manageSubs.addCustomersError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(addCustomers(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissAddCustomersError());
  }, [dispatch]);

  return {
    addCustomers: boundAction,
    addCustomersPending,
    addCustomersError,
    dismissAddCustomersError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_ADD_CUSTOMERS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        addCustomersPending: true,
        addCustomersError: null,
      };

    case MANAGE_SUBS_ADD_CUSTOMERS_SUCCESS:
      // The request is success
      return {
        ...state,
        addCustomersPending: false,
        addCustomersError: null,
      };

    case MANAGE_SUBS_ADD_CUSTOMERS_FAILURE:
      // The request is failed
      return {
        ...state,
        addCustomersPending: false,
        addCustomersError: action.data.error,
      };

    case MANAGE_SUBS_ADD_CUSTOMERS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        addCustomersError: null,
      };

    default:
      return state;
  }
}
